<template>
    <div class="user-manage-page">
        <van-popup round closeable v-model="showUserNew">
            <van-form
                @failed="onFailed"
                validate-first
                style="padding-top: 30px; width: 300px"
                @submit="onSubmit"
            >
                <van-field
                    v-model="form.name"
                    name="用户名"
                    label="用户名"
                    placeholder="用户名"
                    :rules="[{ required: true, message: '请填写用户名' }]"
                />
                <van-field
                    v-model="form.telephone"
                    name="手机号码"
                    label="手机号码"
                    placeholder="手机号码"
                    :rules="[
            { required: true, message: '请填写手机号码' },
            { validator, message: '请输入正确手机格式' },
          ]"
                />
                <van-field
                    v-model="form.password"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="密码"
                    :rules="[{ required: true, message: '请填写密码' }]"
                />
                <van-field
                    v-model="form.confirmpassword"
                    type="password"
                    name="确认密码"
                    label="确认密码"
                    placeholder="确认密码"
                    :rules="[
            { required: true, message: '请填写确认密码' },
            {
              validator: validatorConfirmPass,
              message: '确认密码和密码不一致',
            },
          ]"
                />
                <van-field
                    v-model="form.sms"
                    center
                    clearable
                    label="短信验证码"
                    placeholder="请输入短信验证码"
                    :rules="[
            { required: true, message: '请填写短信验证码' },
          ]"
                >
                    <template #button>
                        <van-button @click="sendSms" size="small" type="primary">
                            {{ count < 60 ? '剩余' + count + 's' : '发送验证码' }}
                        </van-button>
                    </template>
                </van-field>
                <div style="margin: 16px">
                    <van-button
                        color="#f24749"
                        round
                        block
                        type="info"

                        native-type="submit"
                    >提交
                    </van-button
                    >
                </div>
            </van-form>
        </van-popup>
        <van-popup closeable v-model="showPassEdit">
            <div class="title">{{users[userindex]&& users[userindex].userName || '' }}更改密码</div>
            <van-form style="padding-top: 40px; width: 300px" @submit="onSubmitEditPass">
                <van-field
                    v-model="password"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="密码"
                    :rules="[{ required: true, message: '请填写密码' }]"
                />
                <van-field
                    v-model="confirmpassword"
                    type="password"
                    name="确认密码"
                    label="确认密码"
                    placeholder="确认密码"
                    :rules="[{ required: true, message: '请填写确认密码' },  {
                validator: validatorConfirmPass2,
              message: '确认密码和密码不一致',
            },]"
                />

                <div style="margin: 16px">
                    <van-button
                        color="#f24749"
                        round
                        block
                        type="info"
                        native-type="submit"
                    >提交
                    </van-button
                    >
                </div>
            </van-form>
        </van-popup>
        <van-popup round closeable v-model="showSetPriceRatio">
            <div class="title">{{users[userindex]&& users[userindex].userName || '' }}设置倍率</div>
            <van-form style="padding-top: 40px; width: 300px" @submit="onSubmitPriceRatio">
                <van-field
                    v-model="priceDisplayTimes"
                    name="倍率"
                    label="倍率"
                    placeholder="倍率"
                    :rules="[{ required: true, message: '请填写倍率' }]"
                />

                <div style="margin: 16px">
                    <van-button
                        color="#f24749"
                        round
                        block

                        type="info"
                        native-type="submit"
                    >提交
                    </van-button
                    >
                </div>
            </van-form>
        </van-popup>
        <van-nav-bar
            title="用户管理"
            left-text="返回"
            right-text="申请子账号"
            left-arrow
            @click-left="goback"
            @click-right="applicationUser"
        />
        <div class="users">
            <van-empty v-if="users.length==0">没有数据</van-empty>
            <div v-for="(item, index) in users" class="user">
                <div class="top-info">
                    <div>{{ item.mobile }}</div>
                    <div>{{ item.userName || '' }}</div>
                    <div>{{ item.priceDisplayTimes }}倍</div>
                </div>
                <div class="bottom-info">
                    <div @click="setPriceRatio(index)">设置倍数</div>
                    <div @click="editPass(index)">更改密码</div>
                    <div @click="deleteUser(index)">删除</div>
                    <div v-if="item.status == 'ACTIVE'" @click="stopOrResume(index)">禁用</div>
                    <div v-else @click="stopOrResume(index)">启用</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Dialog, Toast} from "vant";

export default {
    name: "usermanage",
    data() {
        return {
            count: 60,
            isValid: false,
            showUserNew: false,
            showPassEdit: false,
            showSetPriceRatio: false,
            userindex: 0,
            priceDisplayTimes: "",
            form: {
                status: 1,
                sms: ''
            },
            confirmpassword: "",
            password: "",
            users: [],
        };
    },
    mounted() {
        this.getUsers();
    },
    methods: {
        getUsers() {  //获取用户列表

            // console.log((process.env.VUE_APP_USER_baseURL + 'subUser/' + this.$store.getters.shop_id),1111)
            this.$http.get(process.env.VUE_APP_USER_baseURL + 'subUser/' + this.$store.getters.user.id || 0).then(res => {
                this.users = res || [];
                // console.log(res, 1111)
            })

            /*this.users = [
            {
              id: 1,
              mobile: "13773014328",
              name: "朱xxx",
              price_ratio: "1.3",
              status: 1,
            },
            {
              id: 2,
              mobile: "13773014328",
              name: "朱xxx",
              price_ratio: "1.3",
              status: 1,
            },
            {
              id: 3,
              mobile: "13773014328",
              name: "李",
              price_ratio: "1.3",
              status: 0,
            },
            {
              id: 4,
              mobile: "13773014328",
              name: "王某某",
              price_ratio: "1.3",
              status: 0,
            },
          ]*/
        },
        onFailed(e) {
            // debugger
            //  this.isValid = e.errors.length == 0;
        },
        validator(val) {
            return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                val
            );
        },
        validatorConfirmPass(v) {

            return v == this.form.password;
        },
        validatorConfirmPass2(v) {

            return v == this.password;
        },

        stopOrResume(index) {
            let status = this.users[index].status
            let id = this.users[index].id
            Dialog.confirm({
                title: "确认提醒",
                message: `确定要${status == "ACTIVE" ? '禁用' : '启用'}该账户？`,
                confirmButtonColor: "rgb(242, 71, 73)",
            })
                .then(() => {
                    let url = (status == "ACTIVE" ? 'subUser/0/' : 'subUser/1/') + id
                    this.$http.put(process.env.VUE_APP_USER_baseURL + url).then(res => {
                        this.users[index].status = status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
                      if(res) Toast(res || '操作成功');
                    })
                })
                .catch(() => {
                    // on cancel
                });
        },
        deleteUser(index) {

            let user = this.users[index]
            if(user) {
                Dialog.confirm({
                    title: "确认提醒",
                    message: "删除"+user.userName+"账户？",
                    confirmButtonColor: "rgb(242, 71, 73)",
                })
                    .then(() => {
                        this.$http.delete(process.env.VUE_APP_USER_baseURL + 'subUser/' + user.id).then(res => {

                            // console.log(res,111)
                            this.users.splice(index, 1);
                            Toast('账户删除成功！');
                        });
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
        },
        editPass(index) {
            this.userindex = index
            this.showPassEdit = true;
        },
        setPriceRatio(index) {
            this.userindex = index
            this.priceDisplayTimes = this.users[this.userindex].priceDisplayTimes
            this.showSetPriceRatio = true;
        },
        autoClock() {
            //clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.count--;
                if (this.count == 0) {
                    this.count = 60;
                    clearTimeout(this.timeout)
                }
            }, 1000)
        },
        sendSms() {
            if (this.form.telephone && this.count == 60) {
                //请求后端的发送短信的地方
                this.$http.post(process.env.VUE_APP_USER_baseURL + "/smartCurtain/sendSmsVerifyCode?mobile="+this.form.telephone, {simple:true}).then(_ => {
                    // this.is_disabled = true;
                    /*if (this.is_setInterval) {
                        clearInterval(this.is_setInterval);
                    }
                    this.code_count();*/

                    this.count--;
                    this.autoClock();
                });
            }
        },
        onSubmit() {
            //请求后端保存新用户的地方
            // this.users = this.users.concat([this.form])
            // console.log(this.form);
            this.$http.post(process.env.VUE_APP_USER_baseURL + 'smartCurtain/register', {
                "id": 0,
                "mobile": this.form.telephone,
                "oldPassword": "",
                "parentId": this.$store.getters.user.id,
                "password": this.form.password,
                "token": "",
                "traderId": this.$store.getters.shop_id,
                "type": "",
                "userName": this.form.name,
                "validCode": this.form.sms,
                "simple" : true
            }).then(res => {
                Toast('注册成功！');
                this.getUsers()
                this.form = {};
                this.showUserNew = false;
            });

        },
        onSubmitPriceRatio() {
            //倍率设置成功
            let user = this.users[this.userindex]
            this.$http.put(process.env.VUE_APP_USER_baseURL + 'subUserFunc', {
                "cloudUserId": user.id,
                "parentId": user.parentId,
                "priceDisplayTimes": this.priceDisplayTimes,
                "simple" : true
            }).then(res => {
                this.showSetPriceRatio = false;
                this.users[this.userindex].priceDisplayTimes = this.priceDisplayTimes
                // Toast('倍率设置成功！');
              if(res) Toast(res);
            });
        },
        onSubmitEditPass() {
            // 修改密码
            let user = this.users[this.userindex]

            if(user) {
                this.$http.put(process.env.VUE_APP_USER_baseURL + 'subUser', {
                    "id": user.id,
                    "mobile": user.mobile,
                    "oldPassword": user.password,
                    "parentId": user.parentId,
                    "password": this.password,
                    "token": "",
                    "traderId": user.traderId,
                    "type": "",
                    "userName": user.userName || '',
                    "validCode": user.validCode,
                    "simple": true
                }).then(res => {
                    // console.log(res,111)
                    this.showPassEdit = false;
                    this.users[this.userindex].password = this.password
                    this.password = '';
                    this.confirmpassword = ''
                  if(res) Toast(res);
                });
            }

        },
        applicationUser() {
            this.showUserNew = true;
        },
        goback() {
            history.go(-1);
        },
    },
};
</script>
<style scoped>
.user-manage-page {
    background: #f1f1f1;
    min-height: 100vh;
}

.user {
    background: #fff;
    border-bottom: 1px solid #f1f1f1;
}

.user .top-info {
    background: #fff;
    margin-bottom: 10px;
    font-size: 14px;
    padding: 10px;
    justify-content: space-around;
    display: flex;
    margin-bottom: 0;
}

.user .bottom-info {
    display: flex;
    font-size: 14px;
    justify-content: space-evenly;
    padding-bottom: 10px;
}

.user-manage-page .title {
    position: absolute;
    top: 15px;
    width: 100%;
    text-align: center;
    font-size: 14px;
}
</style>
